// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e837ca8f","453":"41a4a80f","455":"9bc7aaf1","977":"4e7f35a6"}[chunkId] + ".chunk.js";
};